import { render } from "./IconSelectRange.vue?vue&type=template&id=bff8967c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconSelectRange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bff8967c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bff8967c', __exports__)) {
    api.reload('bff8967c', __exports__)
  }
  
  module.hot.accept("./IconSelectRange.vue?vue&type=template&id=bff8967c", () => {
    api.rerender('bff8967c', render)
  })

}


export default __exports__